import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft, Mail, Phone, MapPin, Clock } from 'lucide-react';
import UserHeader from '../../components/header/UserHeader';

const ContactPage = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission here
    console.log('Contact form submitted:', formData);
    alert('Thank you for your message! We will get back to you soon.');
    setFormData({ name: '', email: '', subject: '', message: '' });
  };

  const infoItems = [
    {
      icon: Mail,
      tint: 'bg-blue-50 text-blue-600',
      title: 'Email',
      lines: ['zammer.retail2026@gmail.com', 'Info.zammer@gmail.com']
    },
    {
      icon: Phone,
      tint: 'bg-green-50 text-green-600',
      title: 'Phone',
      lines: ['+91 95127 12841']
    },
    {
      icon: MapPin,
      tint: 'bg-purple-50 text-purple-600',
      title: 'Address',
      lines: [
        'Zammer Retail Private Limited',
        '82 Ravipark Society, Kapodra',
        'Surat, Gujarat - 395006',
        'India'
      ]
    },
    {
      icon: Clock,
      tint: 'bg-amber-50 text-amber-600',
      title: 'Business Hours',
      lines: [
        'Mon - Fri: 9:00 AM - 6:00 PM',
        'Saturday: 10:00 AM - 4:00 PM',
        'Sunday: Closed'
      ]
    }
  ];

  const inputClass =
    'w-full px-3 py-2.5 text-sm border border-gray-300 rounded-lg focus:outline-none focus:border-gray-900 focus:ring-1 focus:ring-gray-900 transition-colors';

  return (
    <>
      <UserHeader />
      <div className="min-h-screen bg-gray-50 pb-24">
        {/* Page sub-header */}
        <div className="flex items-center gap-1.5 px-3 h-12 bg-white border-b border-gray-100">
          <button
            onClick={() => navigate(-1)}
            className="p-1 text-gray-700"
            aria-label="Go back"
          >
            <ChevronLeft className="w-6 h-6" />
          </button>
          <span className="text-[15px] font-semibold text-gray-900">Contact Us</span>
        </div>

        <div className="px-4 py-5 space-y-4">
          {/* Intro */}
          <div className="text-center">
            <h1 className="text-2xl font-bold text-gray-900">Get in touch</h1>
            <p className="text-sm text-gray-500 mt-1">
              We'd love to hear from you — our team usually replies within 24-48 hours.
            </p>
          </div>

          {/* Contact information */}
          <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-5">
            <h2 className="text-base font-semibold text-gray-900 mb-4">Reach us</h2>
            <div className="space-y-5">
              {infoItems.map(({ icon: Icon, tint, title, lines }) => (
                <div key={title} className="flex items-start gap-3">
                  <div
                    className={`flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center ${tint}`}
                  >
                    <Icon className="w-5 h-5" strokeWidth={1.8} />
                  </div>
                  <div className="min-w-0">
                    <h3 className="text-sm font-semibold text-gray-900">{title}</h3>
                    {lines.map((line) => (
                      <p key={line} className="text-sm text-gray-600 break-words">
                        {line}
                      </p>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Contact form */}
          <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-5">
            <h2 className="text-base font-semibold text-gray-900 mb-4">Send us a message</h2>

            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1.5">
                  Full Name
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className={inputClass}
                  placeholder="Enter your full name"
                />
              </div>

              <div>
                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1.5">
                  Email Address
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className={inputClass}
                  placeholder="Enter your email address"
                />
              </div>

              <div>
                <label htmlFor="subject" className="block text-sm font-medium text-gray-700 mb-1.5">
                  Subject
                </label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                  className={inputClass}
                  placeholder="Enter subject"
                />
              </div>

              <div>
                <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1.5">
                  Message
                </label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows={4}
                  className={`${inputClass} resize-none`}
                  placeholder="Enter your message"
                />
              </div>

              <button
                type="submit"
                className="w-full bg-gray-900 text-white py-3 px-6 rounded-lg text-sm font-semibold hover:bg-black transition-colors focus:outline-none focus:ring-2 focus:ring-gray-900 focus:ring-offset-2"
              >
                Send Message
              </button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactPage;
